import OcrListing from './ocrListing';

const ImportDocumentsButton = [
    {
        label: window.i18n.__('Importer des factures ou des avoirs'),
        primary: true,
        disabled: true,
        icon: 'download',
        type: 'function',
        url: {
            event: 'openPurchaseImportModal',
        },
        linkedtype: null,
        featureFlag: 'ocr-purchase',
        permission: 'import',
        databot: 'purchases-list_import-documents',
    },
];

const PurchaseInvoiceNewButton = [
    {
        label: window.i18n.__('Créer une facture fournisseur'),
        primary: true,
        disabled: true,
        databot: 'purchases-purinvoices-list_create-invoice',
        items: [
            {
                label: window.i18n.__('Créer une facture'),
                icon: 'plus',
                href:
                    'javascript:DocTools.createForThird("purInvoice", "' +
                    window.i18n.__('Créer une facture fournisseur') +
                    '")',
                permission: 'create',
                databot: 'purchases-purinvoices-list_create-invoice_docform',
            },
            {
                label: window.i18n.__('Saisie rapide'),
                icon: 'edit',
                href: '/?_f=purchases_fastpurchase&action=loadForm',
                permission: ['create', 'create_fast'],
                databot: 'purchases-purinvoices-list_create-invoice_fast',
            },
            {
                label: window.i18n.__('Importer une facture'),
                icon: 'download',
                type: 'function',
                url: {
                    event: 'openPurchaseImportModal',
                },
                linkedtype: 'purInvoice',
                permission: 'import',
                featureFlag: 'ocr-purchase',
                databot: 'purchases-purinvoices-list_import-invoice',
            },
        ],
    },
];

const PurchaseCreditNoteNewButton = [
    {
        label: window.i18n.__('Créer un avoir fournisseur'),
        primary: true,
        disabled: true,
        databot: 'purchases-purcreditnotes-list_create-creditnote',
        items: [
            {
                label: window.i18n.__('Créer un avoir'),
                icon: 'plus',
                href:
                    'javascript:DocTools.createForThird("purCreditNote", "' +
                    window.i18n.__('Créer un avoir fournisseur') +
                    '")',
                permission: 'create',
                databot: 'purchases-purcreditnotes-list_create-creditnote_docform',
            },
            {
                label: window.i18n.__('Importer un avoir'),
                icon: 'download',
                type: 'function',
                url: {
                    event: 'openPurchaseImportModal',
                },
                linkedtype: 'purCreditNote',
                permission: 'import',
                featureFlag: 'ocr-purchase',
                databot: 'purchases-purcreditnotes-list_import-creditnote',
            },
        ],
    },
];

const PurchaseListing = [
    {
        ...OcrListing[0],
        group: 'purchase',
        buttons: [...ImportDocumentsButton],
    },
    {
        id: 'purchaseinvoices',
        label: window.i18n.__('Factures'),
        buttons: [...PurchaseInvoiceNewButton],
        linkedtype: 'purInvoice',
        name: 'purchaseinvoices',
        group: 'purchase',
    },
    {
        id: 'purchasecreditnotes',
        label: window.i18n.__('Avoirs'),
        buttons: [...PurchaseCreditNoteNewButton],
        linkedtype: 'purCreditNote',
        name: 'purchasecreditnotes',
        group: 'purchase',
    },
];
export default PurchaseListing;
